import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useRequestProcessMethodStyles = makeStyles(
  ({ breakpoints, spacing }) => {
    return {
      container: () => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '80px 0px',
        paddingTop: '40px',
        marginBottom: spacing(15),
        [breakpoints.down('xs')]: {
          paddintTop: '48px'
        }
      }),
      root: {
        justifyContent: 'center',
        width: 'calc(100% - 76px)',
        maxWidth: 794,
        [breakpoints.down('xs')]: {
          flexDirection: 'column',
          alignItems: 'center'
        }
      },
      itemRoot: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        rowGap: '29px',
        columnGap: '16px',
        marginBottom: 24,
        [breakpoints.down('sm')]: {
          width: 524
        },
        [breakpoints.down('xs')]: {
          width: 254,
          flexDirection: 'column',
          alignItems: 'center',
          gap: '21px',
          marginBottom: 40
        }
      },
      item: {
        maxWidth: 'calc(100% / 3 - 16px)',
        cursor: 'pointer',
        margin: '0px 8px',
        [breakpoints.down('xs')]: {
          maxWidth: '100%'
        },
        marginBottom: 40
      },
      servicetype: {
        marginBottom: 12,
        '&:hover': {
          border: `2px solid ${colorSet.primary500}`
        }
      },
      title: {
        border: `1px solid ${colorSet.gray300}`,
        padding: 12,
        '&:hover': {}
      },
      image: {
        border: `1px solid ${colorSet.gray300}`,
        width: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        height: '148px'
      },
      typo: {
        display: 'flex',
        alignItems: 'center',
        color: colorSet.primary800,
        '& svg': {
          width: 20,
          height: 20,
          marginLeft: 12
        }
      },
      span: {
        fontWeight: 700,
        color: colorSet.primary500,
        fontSize: 32,
        [breakpoints.down('xs')]: {
          fontSize: 25
        }
      },
      prevBtn: {
        width: 132,
        height: 48,
        border: `1px solid ${colorSet.gray600}`,
        '& .label': {
          color: colorSet.gray700
        }
      }
    };
  }
);
